(function () {
    'use strict';

    angular.module('ecap.subscriptions', []);
})();